<template>
  <div class="sound-therapy-tabs">
    <button
      v-for="(tab, tI) in tabs"
      :key="tI"
      type="button"
      :class="[
        'sound-therapy-tabs__item',
        {
          'sound-therapy-tabs__item--active': selectedTabValue === tab.value,
        },
      ]"
      @click="emit('update:selectedTabValue', tab.value)"
    >
      {{ tab.title || tab.value }}
    </button>
  </div>
</template>

<script setup lang="ts">
import { UiTherapyTabItemI } from '@/types/ui';

defineProps<{
  tabs: UiTherapyTabItemI[];
  selectedTabValue: UiTherapyTabItemI['value'];
}>();
const emit = defineEmits<{
  (e: 'update:selectedTabValue', value: UiTherapyTabItemI['value']): void;
}>();
</script>

<style lang="scss" scoped>
.sound-therapy-tabs {
  display: flex;
  align-items: center;
  gap: 8px;
  overflow: auto;
  margin: 16px 0;
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }

  &__item {
    font-size: 15px;
    line-height: 24px;
    color: #172659;
    background-color: #ebedfb;
    border-radius: 20px;
    padding: 4px 15px;
    text-transform: capitalize;
    white-space: nowrap;

    &--active {
      color: #fff;
      background-color: #8a90ac;
    }
  }
}
</style>
